import React from "react";
import styled from "styled-components";
import MapGL, {
  Popup,
  Source,
  Layer,
  FlyToInterpolator,
  NavigationControl,
} from "react-map-gl";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";

import data from "../../constants/data_2025_2.json";
import { parseCity } from "../../helpers/parseCity";

import DoughNut from "../Doughnut";
import SidePanel from "../SidePanel/SidePanel";

import "./ReactMapsGL.css";
import Icon from "../../images/CitiIQLarge.svg";
import Global4000 from "../../images/Global4000.png";

import FormDialog from "../Form";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
`;

const IconWrapper = styled.a`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 100;
  background-image: url(${(props) => props.background});
  background-repeat: no-repeat;
  height: 80px;
  width: 160px;
`;
const IconWrapper2 = styled.div`
  position: absolute;
  right: 20px;
  top: 60px;
  z-index: 100;
  background-image: url(${(props) => props.background});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 110px;
  width: 160px;
`;

const PopupContainer = styled.div`
  width: auto;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #1c1f26;
  box-sizing: border-box;
  padding-bottom: 8px;
`;

const Legend = styled.div`
  height: 50px;
  width: 100%;
  background-color: #9ec73d;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: white;
`;

const City = styled.div`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Heebo, sans-serif;
  height: auto;
`;
const Country = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Heebo, sans-serif;
  height: auto;
  margin-left: 5px;
  margin-right: 5px;
`;

const ReactMapsGl = () => {
  const [store] = React.useState(parseCity(data));
  const mapRef = React.useRef(null);
  const [current, setCurrent] = React.useState(null);
  const [hovering, setHovering] = React.useState(false);
  const [timerCountdown, setTimerCountdown] = React.useState(null);
  const [dotSize, SetdotSize] = React.useState(1);

  const [viewport, setViewport] = React.useState({
    latitude: 37.7577,
    longitude: 20.4376,
    zoom: 1,
  });
  const [popupInfo, setPopupInfo] = React.useState(false);

  const handleClick = (marker) => {
    const updateViewport = (longitude, latitude) => {
      let value = 2;
      viewport.zoom > 2 ? (value = viewport.zoom) : (value = 2);
      setViewport({
        longitude,
        latitude,
        zoom: value,
        transitionInterpolator: new FlyToInterpolator({ speed: 1.2 }),
        transitionDuration: "auto",
      });
    };
    updateViewport(marker.longitude, marker.latitude);
    setCurrent(marker);
    setPopupInfo(true);
  };

  const handleMouseOver = (event) => {
    if (event && event.features && event.features.length > 0) {
      setCurrent(event.features[0].properties);
      setPopupInfo(true);
    }
  };

  React.useEffect(() => {
    if (!hovering) {
      setTimerCountdown(setTimeout(() => setPopupInfo(false), 1500));
    }
    if (hovering) {
      setTimerCountdown(clearTimeout(timerCountdown));
    }
    /* eslint-disable-next-line */
  }, [hovering]);

  React.useEffect(() => {
    if (viewport.zoom < 2) {
      SetdotSize(1);
    }
    if (viewport.zoom >= 2 && viewport.zoom < 4.5) {
      SetdotSize(3);
    }
    if (viewport.zoom > 4.5) {
      SetdotSize(5);
    }
  }, [viewport]);

  return (
    <React.Fragment>
      <Container>
        <IconWrapper
          background={Icon}
          href="https://www.citiiq.com/"
          target="_blank"
        ></IconWrapper>
        <IconWrapper2 background={Global4000} />
        <SidePanel store={store} handleClick={handleClick} />

        <MapGL
          {...viewport}
          ref={mapRef}
          width="100vw"
          height="100vh"
          mapStyle="mapbox://styles/mapbox/dark-v10"
          onViewportChange={setViewport}
          interactiveLayerIds={["index0"]}
          onHover={(e) => handleMouseOver(e)}
          onMouseLeave={() => setHovering(false)}
          onMouseEnter={() => setHovering(true)}
          onClick={(e) => handleMouseOver(e)}
          mapboxApiAccessToken={process.env.REACT_APP_MAPBOXGL_KEY}
        >
          <Source id={`index-`} type="geojson" data={store}>
            <Layer
              id={`index0`}
              type="circle"
              paint={{
                "circle-radius": dotSize,
                "circle-color": "#9DC73C",
                "circle-stroke-color": "#9DC73C",
                "circle-stroke-width": 1,
              }}
            />
            {current && popupInfo ? (
              <Popup
                key={`popup-${current.city_name}`}
                tipSize={5}
                anchor="bottom"
                longitude={current.longitude}
                latitude={current.latitude}
                offsetTop={-30}
                offsetLeft={5}
                closeOnClick={true}
                closeButton={false}
                onClose={() => setPopupInfo(true)}
              >
                <PopupContainer>
                  <Legend>
                    <City>{current.address}</City>
                    <Country>{current.country}</Country>
                  </Legend>

                  <DoughNut
                    DoughNutData={current}
                    width={"150px"}
                    color={"#FFFFFF"}
                    overlaySize={"40px"}
                    score={current.score}
                  />
                </PopupContainer>
              </Popup>
            ) : null}
          </Source>
          <NavigationControl className={"NaivgationControlGL"} />
        </MapGL>
      </Container>
      <FormDialog />
    </React.Fragment>
  );
};

export default ReactMapsGl;
